import { Recipient } from './recipient';

export enum ApprovalColumn {
  PRIORITY = 'priority',
  EXTRAWAITTIME = 'extraWaitTime',
  MAXDONORAGE = 'maxDonorAge',
  MAXMISMATCHES = 'maxMismatches',
  ACCEPTABLEBLOODTYPES = 'acceptableBloodTypes',
  ACCEPTABLEHLA = 'acceptableHla',
  LOWMFI1 = 'lowMfi1',
  LOWMFi2 = 'lowMfi2'
}
export enum ApprovalStatus {
  PENDING = 'pending',
  DENIED = 'closed',
  APPROVED = 'approved'
}
export const ApprovalColumnLabels: Record<ApprovalColumn, string> = {
  [ApprovalColumn.ACCEPTABLEBLOODTYPES]: 'Acceptable Blood Types',
  [ApprovalColumn.EXTRAWAITTIME]: 'Extra Wait Time',
  [ApprovalColumn.ACCEPTABLEHLA]: 'Acceptable HLA',
  [ApprovalColumn.MAXDONORAGE]: 'Max Donor Age',
  [ApprovalColumn.MAXMISMATCHES]: 'Max Mismatches',
  [ApprovalColumn.PRIORITY]: 'Priority',
  [ApprovalColumn.LOWMFI1]: 'Low MFI unacceptables class 1 (A/B)',
  [ApprovalColumn.LOWMFi2]: 'Low MFI unacceptables class 2 (DR/DQ)'
};
export interface Approval {
  id?: string;
  approvalColumn: ApprovalColumn;

  //Used for privileges columns
  value?: string;
  recipient: Recipient;
  status: ApprovalStatus;
  dateCreated?: string;
  dateProcessed?: string;
  approvalByUser?: string;
  closedReason?: string;
  approvalReason?: string;
  requestComment?: string;
  requestedAcceptableHla?: string;
  requestedAcceptableBloodTypes?: string;
}
